import { API } from '../../apis/limeAuthUtils/apiWrapper';

/**
 * function to list test runs for user
 * @param email User email
 * @param byRequester yes if your own test runs; no if your team's test runs
 * @param region User selected Region
 * @returns {Promise<any>}
 * @constructor
 */
async function ListTestRunsAPI(email, byRequester, region) {
    const apiName = `${region}/v1/automation-api`;
    const myInit = {
        queryStringParameters: {
            email: email,
            by_requester: byRequester,
        },
    };
    return await API.get(apiName, '/v1/admin/testruns', myInit);
}

/**
 * function to fetch test runs by calling api
 * @param byRequester yes if your own test runs; no if your team's test runs
 * @param region User selected Region
 * @returns {Promise<*>}
 */
export async function fetchTestRuns(email, byRequester, region) {
    return await ListTestRunsAPI(email, byRequester, region);
}
